import styled from "@emotion/styled";
import { Avatar, Box, IconButton, Theme } from "@mui/material";

export const Container = styled(Box)<{ theme: Theme }>((props) => ({
  display: "inline-flex",
  color: "white",
  width: "-webkit-fill-available",
  alignItems: "center",
  padding: props.theme.spacing(1),
}));

export const StyledAvatar = styled(Avatar)<{theme: Theme}>((props) => ({
  width: "30px",
  height: "30px",
  border: "white solid 2px",
  backgroundColor: props.theme.palette.background.default,
  color: "white"
}))

export const StyledIconButton = styled(IconButton)<{theme: Theme}>((props) => ({
  color: props.theme.palette.background.default
}))

export const ListAvatar = styled(Avatar)<{ theme: Theme }>((props) => ({
  width: "30px",
  height: "30px",
  backgroundColor: "unset",
  color: props.theme.palette.secondary.main,
}))